export const RightArrowIcon = () => {
    return (
        <svg viewBox="0 0 318 250" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M25.6667 125C181.877 125 136.123 125 292.333 125M292.333 125L192.333 25M292.333 125L192.333 225" stroke="#1C274C" strokeWidth="50" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
}